import { render } from "./AdminUserAddressesElement.vue?vue&type=template&id=627b848c&scoped=true"
import script from "./AdminUserAddressesElement.vue?vue&type=script&lang=js"
export * from "./AdminUserAddressesElement.vue?vue&type=script&lang=js"

import "./AdminUserAddressesElement.vue?vue&type=style&index=0&id=627b848c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627b848c"]])

export default __exports__